<template>
  <div>
    <slot :loading="loading" :startExport="startExport" />
  </div>
</template>

<script>
const logo = require('../images/logo.png');
import html2pdf from 'html2pdf.js';

export default {
  props: {
    title: { required: false, type: String, default: 'export' },
    target: { required: true, type: String }
  },

  data() {
    return {
      loading: false
    };
  },

  methods: {
    startExport() {
      this.loading = true;

      Promise.resolve()
        .then(() => this.togglePrintMode(true))
        .then(() => this.wait(1000)) // Wait for any animation to complete
        .then(() => this.scrollTop()) // We have to scroll to the top for the PDF to work
        .then(() => this.awaitNextTick())
        .then(() => this.generatePDF())
        .then((pdf) => this.addFooter(pdf))
        .then((pdf) => pdf.save(`${this.title}.pdf`))
        .then(() => this.togglePrintMode(false))
        .then(() => (this.loading = false));
    },

    scrollTop() {
      window.scrollTo(0, 0);
    },

    generatePDF() {
      return html2pdf()
        .set({
          margin: [25, 15],
          pagebreak: {
            before: ['.print-break-before'],
            after: ['.print-break-after'],
            avoid: ['.print-break-avoid']
          },
          enableLinks: true,
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' }
        })
        .from(document.querySelector(this.target))
        .toPdf()
        .get('pdf');
    },

    wait(milliseconds) {
      return new Promise((resolve) => setTimeout(() => resolve(), milliseconds));
    },

    addFooter(pdf) {
      // First we have to fetch the logo and convert it to base64
      return (
        new Promise(async (resolve, reject) => {
          const response = await fetch(logo);
          const logoBlob = await response.blob();
          const reader = new FileReader();
          reader.onload = function() {
            resolve({ pdf, logo: this.result });
          }; // <--- `this.result` contains a base64 data URI
          reader.readAsDataURL(logoBlob);
        })
          // Then we can actually add the footer
          .then(({ pdf, logo }) => {
            const totalPages = pdf.internal.getNumberOfPages();
            const width = pdf.internal.pageSize.getWidth();
            const height = pdf.internal.pageSize.getHeight();

            // Text styles
            pdf.setFontSize(9);
            pdf.setTextColor(160, 160, 160);

            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i);

              pdf.setDrawColor(230, 230, 230);
              pdf.setLineWidth(0.1);
              pdf.line(22, height - 18, width - 22, height - 18, 'S');
              pdf.addImage(logo, 15, height - 15, 116 / 5, 63 / 5, null, 'NONE');
              pdf.text(width - 30, height - 8, `Page ${i} of ${totalPages}`);
              pdf.text(55, height - 8, `This report was exported at https://eucyberdirect.eu/.`);
            }

            return pdf;
          })
      );
    },

    togglePrintMode(value) {
      document.body.classList.toggle('pdf-exporting', !!value);
      this.$emit(value ? 'export-start' : 'export-end');
    },

    awaitNextTick() {
      return new Promise((resolve) => this.$nextTick(() => resolve()));
    }
  }
};
</script>
